import type { GPHPayment, ContractorPayrollAggregatedStatus } from "../types";

export function computeAggregatedStatus(payments: GPHPayment[]): ContractorPayrollAggregatedStatus {
  if (payments.length === 0) return "all_pending";

  const allPaid = payments.every((p) => p.status === "paid");
  if (allPaid) return "all_paid";

  const somePaid = payments.some((p) => p.status === "paid");
  if (somePaid) return "partially_paid";

  const allApproved = payments.every((p) => p.status === "approved");
  if (allApproved) return "all_approved";

  const someApproved = payments.some((p) => p.status === "approved");
  if (someApproved) return "partially_approved";

  return "all_pending";
}

export function computeDetailStats(payments: GPHPayment[]) {
  let totalGross = 0;
  let totalNet = 0;
  let totalWithheld = 0;

  for (const p of payments) {
    totalGross += Number(p.gross_amount) || 0;
    totalNet += Number(p.net_amount) || 0;
    totalWithheld += Number(p.total_withheld) || 0;
  }

  return {
    contractorCount: payments.length,
    totalGross: String(totalGross),
    totalNet: String(totalNet),
    totalWithheld: String(totalWithheld),
  };
}
